const user =
  window.sessionStorage.getItem("user") &&
  JSON.parse(window.sessionStorage.getItem("user") || "");

export const STATUS_CODES = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHENTICATED: 401,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const QUERY_KEYS = {
  ALLOWED_VALUES: "allowedValues",
  DATA_READINESS_URL: "dataReadinessUrl",
  TARGETS_DASHBOARD_URL: "targetsUrl",
  COLLECTORS: "collectors",
  COLLECTORS_ALL: "collectorsAll",
  COMMENTS: "comments",
  SCIENTIFIC_UNIT: "scientificUnit",
  ESTIMATE_COMMENTS: "estimateComments",
  EMISSION_FACTORS: "emissionFactors",
  EMISSION_FACTOR_BY_SITE: "utility-type-conversion/allsites",
  MISSING_DOCUMENTS: "missingDocuments",
  NOTIFICATIONS: "notifications",
  SITES: "sites",
  SITES_PAGINATED: "sites/v2",
  SITES_EMISSIONS: "sitesEmissions",
  AUDIT_LOGS: '/audit-log/search',
  SCOPE_SITES_EMISSIONS: "supplies/",
  SCOPE_SITES_POPUP_EMISSIONS: "supplies",
  USERS: "users",
  UTILITY_BILLS: "utilityBills",
  DOCUMENTS: "documents",
  UNIT_CONFIGURATION: "unitConfiguration",
  CONFIG_PARAMETER: "configParameter",
  SITE_EMISSION_DETAIL: "billdetailsbysiteutility",
  DOCUMENT_BILLS: "documents/*/bills",
  USER_SETTINGS: "userSettings",
  ESTIMATES: "estimates",
  INTENSITY: "intensity",
  INTENSITYSITE: "intensitysite",
  // TODO: TEMPORAL - REMOVE when Intensity external link functionality is removed
  INTENSITY_EMBED_URL: "intensityEmbedUrl",
  FILESREPO: "filesrepo",
  RENEWABLE_ENERGY_PURCHASES: "/renewable-energy-purchase",
  JOBS: "jobs",
  SCORECARD_CONFIG: "scorecardConfig",
  SCORECARD_DATA: "scorecardData",
  SCORECARD_TEMPLATES: "scorecardTemplates",
  KPI_SUMMARY: "kpiSummary",
  SCORECARD_DOCUMENTS: "scorecardDocuments",
  EMISSION_TARGETS: "emissionTargets",
};

export const QUERY_PARAMS_KEYS = {
  PAGE_SIZE: "pageSize",
  PAGE_NUMBER: "pageNumber",
  SEARCH: "search",
  UTILITY_TYPE_IDS: "utilityTypeIds",
  COUNTRY_REGION: "country_region",
  SITE_IDS: "siteIds",
  STATUSES: "statuses",
  YEAR: "year",
  MONTH: "month",
  EXPANDED_ROWS: "expandedRows",
  SORT_BY: "sortBy",
  SORT_DIRECTION: "sortDirection",
};

export const LOCAL_STORAGE_KEYS = {
  // Document upload
  DOCUMENT_UPLOAD_PAGE_PAGINATION: "DOCUMENT_UPLOAD_PAGE_PAGINATION",
  DOCUMENT_UPLOAD_PAGE_FROM_DATE: "DOCUMENT_UPLOAD_PAGE_FROM_DATE",
  DOCUMENT_UPLOAD_PAGE_TO_DATE: "DOCUMENT_UPLOAD_PAGE_TO_DATE",
  DOCUMENT_UPLOAD_PAGE_SITES_FILTER: "DOCUMENT_UPLOAD_PAGE_SITES_FILTER",
  DOCUMENT_UPLOAD_PAGE_DATA_ENTRIES_STATUS_FILTER: "DOCUMENT_UPLOAD_PAGE_DATA_ENTRIES_STATUS_FILTER",
  DOCUMENT_UPLOAD_PAGE_COLUMN_FILTERS: "DOCUMENT_UPLOAD_PAGE_COLUMN_FILTERS",

  // Document summary (Bill Entries)
  DOCUMENT_SUMMARY_PAGE_PAGINATION: "DOCUMENT_SUMMARY_PAGE_PAGINATION",
  DOCUMENT_SUMMARY_PAGE_START_DATE: "DOCUMENT_SUMMARY_PAGE_START_DATE",
  DOCUMENT_SUMMARY_PAGE_END_DATE: "DOCUMENT_SUMMARY_PAGE_END_DATE",
  DOCUMENT_SUMMARY_PAGE_SITES_FILTER: "DOCUMENT_SUMMARY_PAGE_SITES_FILTER",
  DOCUMENT_SUMMARY_PAGE_COLUMN_FILTERS: "DOCUMENT_SUMMARY_PAGE_COLUMN_FILTERS",
  DOCUMENT_SUMMARY_PAGE_IS_EDITED: "DOCUMENT_SUMMARY_PAGE_IS_EDITED",
  DOCUMENT_SUMMARY_PAGE_IS_MY_TASK: "DOCUMENT_SUMMARY_PAGE_IS_MY_TASK",
  DOCUMENT_SUMMARY_PAGE_SHOW_DUPLICATES: "DOCUMENT_SUMMARY_PAGE_SHOW_DUPLICATES",

  // Approvals
  APPROVALS_PAGE_PAGINATION: "APPROVALS_PAGE_PAGINATION",

  // Missing documents
  MISSING_DOCUMENTS_PAGE_PAGINATION: "MISSING_DOCUMENTS_PAGE_PAGINATION",
  MISSING_DOCUMENTS_PAGE_FISCAL_YEAR: "MISSING_DOCUMENTS_PAGE_FISCAL_YEAR",
  MISSING_DOCUMENTS_PAGE_COUNTRY: "MISSING_DOCUMENTS_PAGE_COUNTRY",
  MISSING_DOCUMENTS_PAGE_UTILITY_TYPE: "MISSING_DOCUMENTS_PAGE_UTILITY_TYPE",
  MISSING_DOCUMENTS_PAGE_SITE_IDS: "MISSING_DOCUMENTS_PAGE_SITE_IDS",
  MISSING_DOCUMENTS_PAGE_BUSINESS_UNIT: "MISSING_DOCUMENTS_PAGE_BUSINESS_UNIT",
  MISSING_DOCUMENTS_PAGE_COUNTRY_REGION: "MISSING_DOCUMENTS_PAGE_COUNTRY_REGION",
  MISSING_DOCUMENTS_PAGE_STATUS: "MISSING_DOCUMENTS_PAGE_STATUS",
  MISSING_DOCUMENTS_PAGE_COLUMN_FILTERS: "MISSING_DOCUMENTS_PAGE_COLUMN_FILTERS",

  // Scorecard
  SCORECARD_PAGE_COLUMN_FILTERS: "SCORECARD_PAGE_COLUMN_FILTERS",

  // Dashboard
  DASHBOARD_PAGE_VARIANCE_START_DATE: "DASHBOARD_PAGE_VARIANCE_START_DATE",
  DASHBOARD_PAGE_VARIANCE_END_DATE: "DASHBOARD_PAGE_VARIANCE_END_DATE",
  DASHBOARD_PAGE_DATE_RANGE_START_DATE: "DASHBOARD_PAGE_DATE_RANGE_START_DATE",
  DASHBOARD_PAGE_DATE_RANGE_END_DATE: "DASHBOARD_PAGE_DATE_RANGE_END_DATE",
};

export const DATE_FORMAT =
  user && user.dateFormat === "DD-MM-YYYY" ? "D MMM, YYYY" : "MMM D, YYYY";

export const REQUIRED_VALIDATION_MESSAGE = "Field is required";

export const PROMISE_STATE = {
  rejected: "rejected",
  fulfilled: "fulfilled",
} as const;

export const TABLE_HEADERS = {
  accountNumber: "Account #",
  meterNumber: "Meter #",
  uploader: "Uploader",
  GHG_Emissions: "GHG Emissions"
};

export const AUDIT_LOGS_EVENT: Record<string, string> = {
  INSERT: "The following details have been created: ",
  UPDATE: "The following changes have been made: ",
  DELETE: "The following details have been deleted:",
};

export const AUDIT_LOGS_COLOR: Record<string, string> = {
  INSERT: "#E1EFE6",
  UPDATE: "#E1EFE6",
  DELETE: "#FCE8E7",
};

export const APPLICATION_JSON = "application/json";
export const FORM_DATA = "multipart/form-data";

export const ALL_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const EMPTY_CELL_VALUE = "-";
export const ROWS_PER_PAGE_OPTIONS = [50, 100, 200];

export const BASE_WARNING_MESSAGE: string = "Failed to extract";

export const WARNING_MESSAGES: Record<string, string> = {
  endDate: `${BASE_WARNING_MESSAGE} end date`,
  startDate: `${BASE_WARNING_MESSAGE} start date`,
  provider: `${BASE_WARNING_MESSAGE} utility provider`,
  type: `${BASE_WARNING_MESSAGE} utility type`,
  measuredValue: `${BASE_WARNING_MESSAGE} usage`,
  measuredUnit: `${BASE_WARNING_MESSAGE} unit`,
  amount: `${BASE_WARNING_MESSAGE} cost`,
  currency: `${BASE_WARNING_MESSAGE} currency`,
  collector: `${BASE_WARNING_MESSAGE} utility account information`,
  subtype: `${BASE_WARNING_MESSAGE} subtype`,
  traveledMiles: `${BASE_WARNING_MESSAGE} traveled miles`,
} as const;
